<template>
  <div class="chat-container">
    <div v-if="!aberto" class="chat-button" @click="aberto = true">
      💬 Fale Conosco
    </div>

    <div v-else class="chat-window">
      <div class="chat-header">
        <span>💬 Fale Conosco</span>
        <button @click="aberto = false">×</button>
      </div>

      <form @submit.prevent="enviarMensagem" class="chat-form">
        <input
          v-model="registerForm.nome"
          type="text"
          placeholder="Seu nome"
          required
        />
        <input
          v-model="registerForm.email"
          type="email"
          placeholder="Seu email"
          required
        />
        <input
          v-model="registerForm.assunto"
          type="text"
          placeholder="Assunto"
          required
        />
        <textarea
          v-model="registerForm.mensagem"
          placeholder="Sua mensagem..."
          required
        ></textarea>
        <button type="submit" :disabled="carregando">
          {{ carregando ? "Enviando..." : "Enviar" }}
        </button>
      </form>

      <!-- Mensagens de sucesso e erro -->
      <p v-if="registerSuccessMessage" class="mensagem" style="color:green">{{ registerSuccessMessage }}</p>
      <p v-if="registerErrorMessage" class="mensagem" style="color:red">{{ registerErrorMessage }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_ENDPOINT } from "../main.js";

export default {
  name: "ChatFlutuante",
  data() {
    return {
      aberto: false,
      carregando: false,
      registerForm: { nome: "", email: "", assunto: "", mensagem: "" },
      registerSuccessMessage: "",
      registerErrorMessage: "",
      timeoutId: null, // para controlar o timeout
    };
  },
  methods: {
    async enviarMensagem() {
      this.carregando = true;
      this.registerSuccessMessage = "";
      this.registerErrorMessage = "";

      try {
        const res = await axios.post(`${API_ENDPOINT}/api/mensagem-request`, this.registerForm);

        if (res.data.success) {
          this.registerSuccessMessage = res.data.message;
          this.registerForm = { nome: "", email: "", assunto: "", mensagem: "" };
        } else {
          this.registerErrorMessage = res.data.message || "Erro ao enviar mensagem.";
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.registerErrorMessage = err.response.data.message || "Erro ao enviar mensagem.";
        } else {
          this.registerErrorMessage = "Erro ao enviar mensagem.";
        }
        console.error(err);
      } finally {
        this.carregando = false;

        // Limpa mensagens e fecha o chat após 5 segundos
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
          this.registerSuccessMessage = "";
          this.registerErrorMessage = "";
          this.aberto = false;
        }, 5000);
      }
    },
  },
};
</script>



<style scoped>
.chat-container {
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 9999;
  font-family: "Poppins", sans-serif;
}

/* Botão flutuante */
.chat-button {
  background-color: #23b7c7;
  color: white;
  padding: 14px 20px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
}
.chat-button:hover {
  background-color: #1ca1b0;
  transform: scale(1.05);
}

/* Janela de chat */
.chat-window {
  width: 400px;
  max-width: 90vw; /* Adapta a largura ao ecrã */
  height: auto;
  max-height: 80vh; /* Limita a altura no celular */
  overflow-y: auto; /* Rolagem automática se o conteúdo for grande */
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
  padding: 18px;
  animation: fadeIn 0.3s ease;
}

/* Cabeçalho */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  background-color: #23b7c7;
  border-radius: 10px;
  padding: 10px 15px;
  font-size: 1.1rem;
}
.chat-header button {
  background: none;
  border: none;
  color: white;
  font-size: 1.3rem;
  cursor: pointer;
}

/* Formulário */
.chat-form {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
}
.chat-form input,
.chat-form textarea {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #cfd9de;
  outline: none;
  transition: 0.2s;
  font-size: 0.95rem;
}
.chat-form input:focus,
.chat-form textarea:focus {
  border-color: #23b7c7;
  box-shadow: 0 0 4px rgba(35, 183, 199, 0.4);
}
.chat-form button {
  background: #23b7c7;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}
.chat-form button:hover {
  background: #1ca1b0;
  transform: scale(1.03);
}

/* Mensagens */
.mensagem {
  margin-top: 12px;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 500;
}

/* Animação */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade — adapta o layout em telas menores */
@media (max-width: 600px) {
  .chat-container {
    bottom: 15px;
    right: 15px;
  }

  .chat-window {
    width: 95vw;
    padding: 15px;
  }

  .chat-header {
    font-size: 1rem;
    padding: 8px 12px;
  }

  .chat-form input,
  .chat-form textarea {
    font-size: 0.9rem;
  }

  .chat-button {
    padding: 12px 16px;
    font-size: 0.9rem;
  }
}
</style>
